var $ = require('../../modules/$');
module.exports = function defineProperty(it, key, desc){
  return $.setDesc(it, key, desc);
};


//////////////////
// WEBPACK FOOTER
// ./~/_core-js@1.2.7@core-js/library/fn/object/define-property.js
// module id = 385
// module chunks = 0